import { MolhamApiCurrency, MolhamListTargetable } from "apiTypes";
import useFormatNumbers from "customHooks/useFormatNumbers";
import { nextCheckoutItemSourceManager } from "customHooks/useNextCheckoutItemSource";
import useTranslation from "next-translate/useTranslation";
import Image from "next/legacy/image";
import Link from "next/link";
import { tragetableFallbackImg } from "../../../config";

type Props = {
  target: MolhamListTargetable;
  routeUrl?: string;
  curr?: MolhamApiCurrency;
};
const OtherOption = ({ target, routeUrl, curr }: Props) => {
  const { contents, preview_image, id, required_amount } = target;

  const { t } = useTranslation("common");
  const { formatNumbers } = useFormatNumbers();
  if (routeUrl === undefined) {
    return null;
  }

  return (
    <div
      onClick={() => {
        nextCheckoutItemSourceManager.setNextCheckoutItemSource(
          nextCheckoutItemSourceManager.options.single_targetable_sidebar
        );
      }}
      className="d-flex align-items-center pb-1 mb-3"
    >
      <Link
        prefetch={false}
        href={`/${routeUrl}/${id}`}
        className="d-flex flex-shrink-0"
      >
        <Image
          unoptimized
          className="rounded object-fit-cover"
          src={preview_image?.thumbnails?.["1:1"] || tragetableFallbackImg}
          style={{ width: 85, height: 85 }}
          blurDataURL={
            preview_image
              ? preview_image?.blurry["1:1"]
              : "https://miro.medium.com/max/928/1*mAMNQhfjxQ0OhYtysV3OmQ.jpeg"
          }
          placeholder="blur"
          alt={contents?.title}
          width={64}
          height={64}
        />
      </Link>
      <div className="ps-2 ms-1">
        <h4
          className="fs-md nav-heading mb-1 adjust-text-2-col"
          style={{ maxWidth: "24ch" }}
        >
          <Link
            prefetch={false}
            href={`/${routeUrl}/${id}`}
            className="fw-bold"
          >
            {contents?.title}
          </Link>
        </h4>
        <p className="fs-md text-muted mb-0">
          {t("required_amount")}
          <span className="fw-bold ms-1 fs-md" dir="ltr">
            {formatNumbers(required_amount?.amount?.[curr?.code])}
          </span>
        </p>
      </div>
    </div>
  );
};

export default OtherOption;
